import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-f089350b06/icons';

// Styled.
import * as S from './styled';

const icons = {
  info: byPrefixAndName.fal['circle-info'],
  warning: byPrefixAndName.fal['triangle-exclamation'],
  error: byPrefixAndName.fal['circle-exclamation'],
  success: byPrefixAndName.fal['circle-check'],
};

const Alert = ({
  title = undefined,
  message = undefined,
  children = undefined,
  icon = undefined,
  className = '',
  info = false,
  warning = false,
  error = false,
  success = false,
  onDismiss = null,
}) => {
  const [visible, setVisible] = useState(true);
  const handleDismiss = useCallback(() => {
    setVisible(false);
    if (onDismiss) onDismiss();
  }, [onDismiss]);

  if (!visible) {
    return null;
  }
  // Determine which icon to use based on the props.
  const iconType = Object.entries({
    info,
    warning,
    error,
    success,
  }).find(([, value]) => value)?.[0];

  // If an icon is provided, use it. Otherwise, use the iconType.
  const iconComponent = icon || (iconType ? icons[iconType] : null);

  const alertType =
    (info && 'info') ||
    (warning && 'warning') ||
    (error && 'error') ||
    (success && 'success') ||
    'regular';

  return (
    <S.Alert className={className} alertType={alertType}>
      {children || (
        <>
          {iconComponent && (
            <S.Icon>
              <FontAwesomeIcon icon={iconComponent} size="lg" />
            </S.Icon>
          )}
          <S.Content>
            {title && <S.Title>{title}</S.Title>}
            {message && <S.Message>{message}</S.Message>}
          </S.Content>
          {onDismiss && (
            <S.Dismiss onClick={handleDismiss} type="button" aria-label="Dismiss">
              <FontAwesomeIcon icon={byPrefixAndName.fal.xmark} />
            </S.Dismiss>
          )}
        </>
      )}
    </S.Alert>
  );
};

Alert.propTypes = {
  title: PropTypes.any,
  message: PropTypes.any,
  className: PropTypes.string,
  info: PropTypes.bool,
  warning: PropTypes.bool,
  error: PropTypes.bool,
  success: PropTypes.bool,
  onDismiss: PropTypes.func,
  children: PropTypes.any,
  icon: PropTypes.instanceOf(FontAwesomeIcon),
};

export default Alert;
